import PropTypes from 'prop-types';

export default (condition, propType) => (props, propName, componentName) => {
  const shouldCheck = typeof condition === 'function' ? condition(props, propName) : props[condition];

  if (shouldCheck) {
    return PropTypes.checkPropTypes({
      [propName]: propType
    }, props, propName, componentName);
  }
};



// WEBPACK FOOTER //
// ./src/utils/shapes/conditional.js